import Aside from "../Component/Aside";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Pengumuman from "../Component/Pengumuman";

export default function PengumumanExample() {
    return <>
        <Header />
        <Aside />
        <Pengumuman />
        <Footer />
    </>
}